import queryString from "query-string";
import {
  setInvoicesCopy,
  updateInvoiceCopy,
  addInvoiceCopy,
} from "./appifyActions";
import { privateFetch, privateFetchNoBody, privateFetchWithToken } from "apis";

import { removeEmptyParams } from "helpers";
import { publicFetch } from "../../apis";

// Deal Action Dispatchers
export const setInvoices = (invoices) => ({
  type: "SET_INVOICES",
  invoices,
});

export const removeInvoices = () => ({
  type: "REMOVE_INVOICES",
});

export const removeInvoice = (invoice) => ({
  type: "REMOVE_INVOICE",
  invoice,
});

export const updateInvoice = (invoice) => ({
  type: "UPDATE_INVOICE",
  invoice,
});

export const addTempInvoice = (appId, invoice) => ({
  type: "ADD_TEMP_INVOICE",
  appId,
  invoice,
});

export const updateTempInvoice = (invoice) => ({
  type: "UPDATE_TEMP_INVOICE",
  invoice,
});

// Get All Invoices metadata
export const getInvoicesMetadataForApp = (appId, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoicesMetadata`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      }).then((invoices) => {
        dispatch(setInvoices(invoices));
        dispatch(setInvoicesCopy(invoices));
        return invoices;
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    }).then((invoices) => {
      dispatch(setInvoices(invoices));
      dispatch(setInvoicesCopy(invoices));
      return invoices;
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

// GET invoice by uuid (readonly)
// {{baseUrl}}/customer/invoice?uuid=NZs1-9a5778f0b6524a58a030d2ed1494f84c

export const getInvoiceByUUId = (uuId) => (dispatch) => {
  const url = __BASE_API_URL__ + `/customer/invoice?uuid=${uuId}`;

  try {
    const result = publicFetch(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
    }).then((invoice) => {
      return invoice;
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

// GET invoice by id

export const getInvoiceById = (appId, id, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoice/${id}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      }).then((invoice) => {
        return invoice;
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    }).then((invoice) => {
      return invoice;
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

// GET all invoices associated with an appId
export const getInvoicesForApp = (appId, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoices`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      }).then((invoices) => {
        dispatch(setInvoices(invoices));
        dispatch(setInvoicesCopy(invoices));
        return invoices;
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    }).then((invoices) => {
      dispatch(setInvoices(invoices));
      dispatch(setInvoicesCopy(invoices));
      return invoices;
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

// Save an invoice

export const saveInvoice =
  (appId, invoice, accessToken) => async (dispatch) => {
    const url = __BASE_API_URL__ + `/app/${appId}/invoice/${invoice.id}`;

    if (accessToken) {
      try {
        const result = privateFetchWithToken(url, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: accessToken,
          }),
          body: JSON.stringify(invoice),
        }).then((invoice) => {
          return invoice;
        });
        return result;
      } catch (e) {
        console.error(e);
      }
    }

    try {
      const result = privateFetch(url, {
        method: "PUT",
        body: JSON.stringify(invoice),
      }).then((invoice) => {
        console.dir(invoice);
        return invoice;
      });
      return result;
    } catch (e) {
      console.error(e);
    }
  };

export const createInvoice =
  (appId, invoice, accessToken) => async (dispatch) => {
    const newInvoice = await postInvoice(appId, invoice, accessToken);
    console.dir(newInvoice);
    // dispatch(updateTempInvoice(newInvoice));
    // dispatch(addInvoiceCopy(newInvoice));
    return newInvoice;
  };

// POST a Invoice to the database
const postInvoice = (appId, invoice, accessToken) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoice`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(invoice),
      }).then((invoice) => {
        return invoice;
      });
      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(invoice),
    }).then((invoice) => {
      console.dir(invoice);
      return invoice;
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

// DELETE a Invoice in database

export const deleteInvoice = (appId, id, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoice/${id}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      }).then((res) => {
        return res;
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  return privateFetch(url, {
    method: "DELETE",
  }).then((res) => {
    if (res) {
      console.log("got delete object back");
      console.dir(res);

      // dispatch(getInvoices(appId));
    }
  });
};

export const createInvoiceItem =
  (appId, invoiceId, item, accessToken) => async (dispatch) => {
    const newInvoice = await postInvoiceItem(
      appId,
      invoiceId,
      item,
      accessToken
    );
    console.dir(newInvoice);
    // dispatch(updateTempInvoice(newInvoice));
    // dispatch(addInvoiceCopy(newInvoice));
    return newInvoice;
  };

// POST a Invoice to the database
const postInvoiceItem = (appId, invoiceId, item, accessToken) => {
  const url =
    __BASE_API_URL__ + `/app/${appId}/invoice/${invoiceId}/invoiceItem`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(item),
      }).then((invoice) => {
        return invoice;
      });
      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(item),
    }).then((invoice) => {
      console.dir(invoice);
      return invoice;
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const saveInvoiceItem =
  (appId, invoiceId, item, accessToken) => async (dispatch) => {
    const url =
      __BASE_API_URL__ +
      `/app/${appId}/invoice/${invoiceId}/invoiceItem/${item.id}`;

    if (accessToken) {
      try {
        const result = privateFetchWithToken(url, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: accessToken,
          }),
          body: JSON.stringify(item),
        }).then((invoice) => {
          return invoice;
        });
        return result;
      } catch (e) {
        console.error(e);
      }
    }

    try {
      const result = privateFetch(url, {
        method: "PUT",
        body: JSON.stringify(item),
      }).then((invoice) => {
        console.dir(invoice);
        return invoice;
      });
      return result;
    } catch (e) {
      console.error(e);
    }
  };

export const deleteInvoiceItem =
  (appId, invoiceId, id, accessToken) => (dispatch) => {
    const url =
      __BASE_API_URL__ + `/app/${appId}/invoice/${invoiceId}/invoiceItem/${id}`;

    if (accessToken) {
      try {
        const result = privateFetchWithToken(url, {
          method: "DELETE",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: accessToken,
          }),
        }).then((res) => {
          return res;
        });

        return result;
      } catch (e) {
        console.error(e);
      }
    }

    return privateFetch(url, {
      method: "DELETE",
    }).then((res) => {
      if (res) {
        console.log("got delete object back");
        console.dir(res);
        return res;

        dispatch(updateInvoice(res));
        dispatch(updateInvoiceCopy(res));
        // dispatch(getInvoices(appId));
      }
    });
  };

// send invoice to customer

export const sendInvoice = (appId, id, accessToken) => (dispatch) => {
  const url = __BASE_API_URL__ + `/app/${appId}/invoice/${id}/send`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      }).then((res) => {
        dispatch(updateInvoice(res));
        dispatch(updateInvoiceCopy(res));
        return res;
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  return privateFetch(url, {
    method: "POST",
  }).then((res) => {
    if (res) {
      console.log("got delete object back");
      console.dir(res);
      dispatch(updateInvoice(res));
      dispatch(updateInvoiceCopy(res));
      // dispatch(getInvoices(appId));
    }
  });
};
